/*eslint-disable*/
import React from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Dispatch } from "redux";
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../reducer/loginSlice';
import { AuthApis } from "../../apis/authApis";
import { AdminApis } from "../../apis/adminApi";
import { AxiosResponse } from "axios";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/admin-dashboard", icon: "fas fa-tachometer-alt" },
  { label: "Users", path: "/admin-users", icon: "fas fa-users" },
];

const SMS_ITEMS = [
  { label: "SMS Users", path: "/admin-sms-users", icon: "fas fa-wallet" },
  { label: "Sender IDs", path: "/admin-sender-ids", icon: "fas fa-id-card" },
  { label: "Messages", path: "/admin-sms-messages", icon: "fas fa-envelope" },
  { label: "Campaigns", path: "/admin-sms-campaigns", icon: "fas fa-bullhorn" },
  { label: "SMS Settings", path: "/admin-sms-settings", icon: "fas fa-cog" },
];

const BOTTOM_ITEMS = [
  { label: "Withdrawals", path: "/witdrawal-request", icon: "fas fa-money-bill-wave" },
  { label: "Subscriptions", path: "/edit-house", icon: "fas fa-crown" },
];

export default function AdminSidebar() {
  const userLoginData = useSelector((state: any) => state.data.login.value);
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: Dispatch = useDispatch();

  React.useEffect(() => {
    AdminApis.searchName('').then(
      (response: AxiosResponse<any>) => {
        if (!response?.data) {
          dispatch(login([]));
          navigate('/login');
        }
      }
    ).catch(() => {});
  }, []);

  const logOut = () => {
    AuthApis.logout('').then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          dispatch(login([]));
          navigate('/login');
        }
      }
    ).catch(() => {});
  };

  if (userLoginData?.data?.role !== 'admin') {
    logOut();
  }

  const isActive = (path: string) => location.pathname === path;

  const linkClass = (path: string) =>
    "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors " +
    (isActive(path)
      ? "bg-[#0071BC] text-white"
      : "text-[#8A92A6] hover:bg-gray-100 hover:text-gray-800");

  return (
    <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-4">
      <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">

        {/* Mobile toggle */}
        <button
          className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
          type="button"
          onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
        >
          <i className="fas fa-bars">|||</i>
        </button>

        {/* Logo */}
        <Link className="md:block text-left md:pb-2 mr-0 inline-block whitespace-nowrap p-4 px-0 pl-2" to="/">
          <img src="/images/Dashboard/logo.png" alt="Gupta" className="h-8" />
        </Link>

        {/* Nav */}
        <div className={"md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " + collapseShow}>

          {/* Mobile header */}
          <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-gray-200">
            <div className="flex justify-between">
              <Link className="text-left inline-block whitespace-nowrap text-sm font-bold p-4 px-0" to="/">
                <img src="/images/Dashboard/logo.png" alt="Gupta" />
              </Link>
              <button type="button" className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl" onClick={() => setCollapseShow("hidden")}>
                X
              </button>
            </div>
          </div>

          <ul className="md:flex-col md:min-w-full flex flex-col list-none gap-1">

            {/* Main nav */}
            {NAV_ITEMS.map(item => (
              <li key={item.path}>
                <NavLink to={item.path} className={linkClass(item.path)}>
                  <i className={`${item.icon} w-4 text-center`}></i>
                  {item.label}
                </NavLink>
              </li>
            ))}

            <li className="mt-4 mb-1">
              <span className="px-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">
                SMS Management
              </span>
            </li>

            {SMS_ITEMS.map(item => (
              <li key={item.path}>
                <NavLink to={item.path} className={linkClass(item.path)}>
                  <i className={`${item.icon} w-4 text-center`}></i>
                  {item.label}
                </NavLink>
              </li>
            ))}

            <li className="mt-4 mb-1">
              <span className="px-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">
                Finance
              </span>
            </li>

            {BOTTOM_ITEMS.map(item => (
              <li key={item.path}>
                <NavLink to={item.path} className={linkClass(item.path)}>
                  <i className={`${item.icon} w-4 text-center`}></i>
                  {item.label}
                </NavLink>
              </li>
            ))}

            {/* Logout */}
            <li className="mt-8">
              <button onClick={logOut} className="flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium text-red-500 hover:bg-red-50 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M16 13v-2H7V8l-5 4l5 4v-3z"/>
                  <path fill="currentColor" d="M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z"/>
                </svg>
                Log out
              </button>
            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}
